/**
 * Canonical site navigation — the single source of truth for header links.
 *
 * Consumed by both headers so they never drift apart:
 *   - Header      (client/src/components/Header/Header.jsx)      — normal pages
 *   - ProHeader   (client/src/components/ProHeader/ProHeader.jsx) — /terminal
 * Each header renders these items in its OWN markup/CSS — this module only
 * defines the data. **To add / remove / reorder a nav link, edit HERE only.**
 *
 * Field reference:
 *   key         stable id (React key + lookup, e.g. ProHeader skips 'trades')
 *   i18nKey     key under `nav.*` in client/src/i18n/locales/{en,ru,ko,zh}.json
 *   fallback    English fallback, passed as t(i18nKey, fallback)
 *   path        route path; consumers ALWAYS wrap it in localizedPath()
 *   group       'main' (top-level bar) | 'more' (the More dropdown)
 *   badge       optional badge label (e.g. 'NEW')
 *   featureFlag optional PostHog flag; item hidden unless the flag is enabled
 *
 * Array order = render order. Keep main items first, then more items.
 */
const NAV_ITEMS = [
  { key: 'trades',           i18nKey: 'nav.perpetualPosition', fallback: 'Whales',                path: '/trades',            group: 'main' },
  { key: 'chart',            i18nKey: 'nav.indicators',        fallback: 'Indicators',            path: '/chart',             group: 'main', badge: 'NEW' },
  { key: 'hyperliquid',      i18nKey: 'nav.hlPositions',       fallback: 'Hyperliquid',           path: '/hyperliquid',       group: 'main' },
  { key: 'polymarket',       i18nKey: 'nav.polymarket',        fallback: 'Prediction',            path: '/polymarket',        group: 'main' },
  { key: 'stats',            i18nKey: 'nav.marketSummary',     fallback: 'Summary',               path: '/stats',             group: 'main' },

  { key: 'aiTrader',         i18nKey: 'nav.aiTrader',          fallback: 'AI Trader',             path: '/ai-trader',         group: 'more', featureFlag: 'show-ai-trader-nav' },
  { key: 'rsi',              i18nKey: 'nav.rsiHeatmap',        fallback: 'RSI Heatmap',           path: '/rsi',               group: 'more' },
  { key: 'bubbles',          i18nKey: 'nav.bubbles',           fallback: 'Bubbles',               path: '/bubbles',           group: 'more' },
  { key: 'leaderboard',      i18nKey: 'nav.leaderboard',       fallback: 'Leaderboard',           path: '/leaderboard',       group: 'more' },
  { key: 'economicCalendar', i18nKey: 'nav.economicCalendar',  fallback: 'Economic Calendar',     path: '/economic-calendar', group: 'more' },
  { key: 'altcoinIndex',     i18nKey: 'nav.altcoinIndex',      fallback: 'Altcoin Index',         path: '/altcoin-index',     group: 'more' },
  { key: 'etfFlows',         i18nKey: 'nav.etfFlows',          fallback: 'ETF Flows',             path: '/etf-flows',         group: 'more' },
  { key: 'calculator',       i18nKey: 'nav.calculator',        fallback: 'Investment Calculator', path: '/calculator',        group: 'more' },
  { key: 'insights',         i18nKey: 'nav.insights',          fallback: 'Insights',              path: '/insights',          group: 'more' },
  { key: 'liquidationMap',   i18nKey: 'nav.liquidationMap',    fallback: 'Liquidation Map',       path: '/liquidation-map',   group: 'more' },
];

export const MAIN_NAV_ITEMS = NAV_ITEMS.filter((i) => i.group === 'main');
export const MORE_NAV_ITEMS = NAV_ITEMS.filter((i) => i.group === 'more');

export default NAV_ITEMS;
